import { connect } from 'react-redux'
import { compose } from 'redux'
import getData from '../functions/getData'
import { PROGRAM_SELECTIONS_ITEMS } from '../constants/state'

const mapStateToProps = state => ({
    selection: getData(state, PROGRAM_SELECTIONS_ITEMS)
})

const hasSelections = () => WrappedComponent => {

    const HasSelections = props => <WrappedComponent {...props} />

    return compose(
        connect(mapStateToProps, null)
    )(HasSelections)
}

export default hasSelections